import { useEffect, useState } from "react";
import "./VocabularySeminaryStyles.scss";
import { Modal } from "react-bootstrap";
import { useCustomQuery } from "../../../lib/TansTack/hooks/userCustomQuery.hook";
import { useQueryClient } from "@tanstack/react-query";
import { capitalizeFirstLetter, returnFlagByLanguage } from "functions/Functions";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "initFirebase";
import {
	wordsSeminary,
	getAllCategories,
	addWordDb,
	getAllWords,
	getSubCategories,
	deleteWord,
	updateWord,
	allMeanings,
	bookmarkWordFalse,
	deleteCategory,
} from "@api/Vocabulary";
import { Link, useHistory, useParams } from "react-router-dom";
import { NotesModal } from "./components/NotesModal/NotesModal";
import { QuizDefaultInfoModal } from "./components/QuizDefaultInfo/QuizDefaultInfoModal";
import { ConfirmationModal } from "./components/ConfirmationModal/ConfirmationModal";
import { returnWarningTypeImage } from "@containers/VocabularySeminaryContainer/functions/VocabularyFunctions";
import {
	getLangSpanishSimple,
	getDifficultColor2,
} from "@components/Vocabulary/PersonalizedTest/functions/functions";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Check, LENLogo, RocketIcon, Trash } from "assets/Imports";
import ReactQuill, { Quill } from "react-quill";
import { CustomSpinner } from "@components/Spinner/SpinnerMyAccountView";
import { place_holder_vocabulary } from "@utils/PlaceHolders/place-holder-vocabulary";
import { seminariesNumber } from "functions/DefaultValues";
import { processWord } from "functions/Words/words.functions";
import { IWord } from "interfaces/DefaultQuizzes/DefaultQuizzes.interface";

function VocabularySeminaryContainer({ user }) {
	const [modal, setModal] = useState<boolean>(false);
	const [update, setUpdate] = useState<boolean>(false);
	const [word_added, setWordAdded] = useState<boolean>(false);
	const handleClose = () => setModal(false);
	const { seminaryNum } = useParams<any>();
	const [words, setWords] = useState<Array<IWord>>(new Array());
	const [categories, setCategories] = useState<Array<any>>(new Array());
	let categories_opt: any = [];
	const [subcategories, setSubcategories] = useState<Array<any>>(new Array());
	const [wordsBackup, setWordsBackup] = useState<Array<IWord>>(new Array());
	const [word, setWord] = useState<any>({ seminarios: [] });
	const [searchText, setText] = useState<string>("");
	const [sort, setSort] = useState<string>("0");
	const [value, setValue] = useState<string>("");
	const [warningType, setWarningType] = useState<string>("advertencia");
	const { input_buscar_terminos, input_palabra_original, input_palabra_en_español, Kanji, Kanzi } =
		place_holder_vocabulary;
	const [showQuiz, setShowQuiz] = useState<boolean>(false);
	const [quizIndex, setQuizIndex] = useState<number>(0);
	const [quiz, setQuiz] = useState<Array<any>>(new Array());
	const [notesModal, setNotesModal] = useState({
		show: false,
		notes: "",
	});
	const [confirmationModal, setConfirmationModal] = useState({
		show: false,
		title: "",
		message: "",
		loading: false,
		onConfirm: () => {},
	});
	const [loading, setLoading] = useState<boolean>(true);
	const [loadingWords, setLoadingWords] = useState<boolean>();
	const warn = [
		"advertencia",
		"memoria",
		"gramatica",
		"consejo",
		"falso_amigo",
		"similitud",
		"pronunciacion",
		"sabias_que",
	];
	const languages = [
		"french",
		"german",
		"italian",
		"russian",
		"japanese",
		"chinese",
		"portuguese",
		"english",
	];
	const history = useHistory();
	const queryClient = useQueryClient();

	// React Query para cachear los datos del seminario con cache más agresivo
	const {
		data: seminaryData,
		isLoading: isLoadingSeminary,
		refetch: refetchSeminaryData,
	} = useCustomQuery(
		`seminary-${seminaryNum}`,
		() => wordsSeminary(seminaryNum),
		{}, // params
		{
			staleTime: 5 * 60 * 1000, // 5 minutos antes de considerar stale
			gcTime: 10 * 60 * 1000, // 10 minutos en cache
		}
	);

	// React Query para cachear categorías y subcategorías
	const { data: categoriesData, isLoading: isLoadingCategories } = useCustomQuery(
		"categories",
		getAllCategories,
		{}
	);

	const { data: subCategoriesData, isLoading: isLoadingSubCategories } = useCustomQuery(
		"subcategories",
		getSubCategories,
		{}
	);

	// React Query para cachear meanings y allWords
	const { data: meaningsData, refetch: refetchMeaningsData } = useCustomQuery(
		"meanings",
		() => allMeanings({ page: 1, limit: 10 }),
		{}
	);

	const { data: allWordsData, refetch: refetchAllWordsData } = useCustomQuery(
		"all-words",
		getAllWords,
		{}
	);
	var Font = Quill.import("formats/font");
	Font.whitelist = ["cirilico"];
	Quill.register(Font, true);
	var Block = Quill.import("blots/block");
	Block.tagName = "p";
	Block.className = "pre";
	Quill.register(Block, true);
	var toolbarOptions = [
		[{ size: ["small", false, "large", "huge"] }], // custom dropdown
		[{ color: [] }, { background: [] }], // dropdown with defaults from theme
		["bold", "italic", "underline", "strike"],
		[{ indent: "-1" }, { indent: "+1" }], // toggled buttons

		["clean"], // remove formatting button
	];

	const getWords = async () => {
		setLoadingWords(true);

		// Invalidar cache del seminario para obtener datos frescos
		queryClient.invalidateQueries({
			queryKey: [`seminary-${user.id}-${seminaryNum}`],
		});

		const q = query(
			collection(db, "defaultQuizzes"),
			where("seminary", "==", parseInt(seminaryNum))
		);
		const docSnap = await getDocs(q);

		if (docSnap.size > 0) {
			let tempArray: any = [];

			await Promise.all(
				docSnap.docs.map((quiz) => {
					tempArray.push({ id: quiz.id, ...quiz.data() });
					// Invalidar cache del seminario para obtener datos frescos
					queryClient.invalidateQueries({
						queryKey: [`seminary-${user.id}-${seminaryNum}`],
					});
				})
			);
			console.log(tempArray);
			setQuiz(tempArray);
		}

		let temp_words: any = [];

		// Usar datos cacheados de React Query en lugar de llamada directa
		if (seminaryData && seminaryData.seminary) {
			const res = seminaryData;

			// Procesar datos de seminary
			res.seminary?.forEach((element) => {
				// Normalizar subcategorías cuando el backend devuelve 'subcategorias' como array de objetos
				// Ejemplo esperado: subcategorias: [{ id: 10, sub_categoria: "sg.f" }]
				if (Array.isArray(element.subcategorias)) {
					const extracted = element.subcategorias
						.map((sc) => {
							if (!sc) return null;
							if (typeof sc === "string") return sc;
							return sc.sub_categoria ?? null;
						})
						.filter((s) => typeof s === "string" && s.trim().length > 0)
						.map((s) => s.trim());
					if (extracted.length > 0) {
						let base: string[] = [];
						if (Array.isArray(element.sub_categoria)) {
							base = element.sub_categoria.filter((s: any) => typeof s === "string");
						} else if (
							typeof element.sub_categoria === "string" &&
							element.sub_categoria.trim().length > 0
						) {
							base = [element.sub_categoria.trim()];
						}
						element.sub_categoria = Array.from(new Set([...base, ...extracted]));
					} else if (!element.sub_categoria) {
						element.sub_categoria = [];
					}
				}
				element.categoria = [element.categoria];

				// Procesar significados - el backend puede enviar 'significados' o 'significado'
				if (element.significados && Array.isArray(element.significados)) {
					// Si viene como array de objetos: [{id_significado: 100, significado: "tarde", lugar: 0}]
					element.significado = element.significados
						.map((item) => item.significado)
						.filter((s) => s && s.toString().trim() !== "");

					// También conservar los IDs para compatibilidad
					element.id_significado = element.significados.map((item) => item.id_significado);
				} else if (typeof element.significado === "string") {
					// Si viene como string, dividir por | y filtrar elementos vacíos
					element.significado = element.significado
						.split("|")
						.map((s) => s.trim())
						.filter((s) => s !== "");

					// Eliminar duplicados
					element.significado = Array.from(new Set(element.significado));
				} else if (Array.isArray(element.significado)) {
					// Si ya es array, limpiar y eliminar duplicados
					element.significado = element.significado
						.map((s) => (s ? s.toString().trim() : ""))
						.filter((s) => s !== "");

					// Eliminar duplicados
					element.significado = Array.from(new Set(element.significado));
				} else {
					// Fallback: convertir a array
					element.significado = element.significado ? [element.significado] : [];
				}

				// Asegurar que id_significado sea array para compatibilidad
				if (!Array.isArray(element.id_significado)) {
					element.id_significado = element.id_significado ? [element.id_significado] : [];
				}

				// Procesar seminarios: convertir de array de objetos a array de números
				if (element.seminarios && Array.isArray(element.seminarios)) {
					element.seminarios = element.seminarios.map((seminary) => {
						// Si es un objeto con seminary_number, extraer el número
						if (typeof seminary === "object" && seminary.seminary_number !== undefined) {
							return seminary.seminary_number;
						}
						// Si ya es un número, mantenerlo
						return seminary;
					});
				} else if (element.seminarios && typeof element.seminarios === "string") {
					// Si viene como string separado por comas
					element.seminarios = element.seminarios
						.split(",")
						.map((s) => parseInt(s.trim()))
						.filter((n) => !isNaN(n));
				} else {
					// Si no hay seminarios, inicializar como array vacío
					element.seminarios = [];
				}

				if (!temp_words.some((el) => el.word_data_id === element.word_data_id)) {
					if (typeof element.sub_categoria === "string") {
						element.sub_categoria = [element.sub_categoria];
					}
					temp_words.push(element);
				} else {
					temp_words.some((el) => {
						if (el.word_data_id === element.word_data_id) {
							// Agregar significados únicos solamente
							element.significado.forEach((meaning) => {
								if (!el.significado.includes(meaning)) {
									el.significado.push(meaning);
								}
							});

							if (!el.categoria.includes(element.categoria[0])) {
								el.categoria.push(element.categoria[0]);
							}
							if (element.sub_categoria) {
								if (!el.sub_categoria.includes(element.sub_categoria)) {
									el.sub_categoria.push(element.sub_categoria);
								}
							}
						}
					});
				}
			});

			// Procesar idiomas
			temp_words.forEach((element) => {
				if (element.idioma == "french") element.idioma = { idioma: element.idioma, id: 1 };
				else if (element.idioma == "german") element.idioma = { idioma: element.idioma, id: 2 };
				else if (element.idioma == "japanese") element.idioma = { idioma: element.idioma, id: 3 };
				else if (element.idioma == "italian") element.idioma = { idioma: element.idioma, id: 4 };
				else if (element.idioma == "russian") element.idioma = { idioma: element.idioma, id: 5 };
				else if (element.idioma == "chinese") element.idioma = { idioma: element.idioma, id: 6 };
				else if (element.idioma == "portuguese") element.idioma = { idioma: element.idioma, id: 7 };
				else if (element.idioma == "english") element.idioma = { idioma: element.idioma, id: 8 };
			});
			setWords(temp_words);
			setWordsBackup(temp_words);
			getCategoriesSeminary(temp_words);
			if (searchText.length > 1 || sort !== "0") {
				filterByAll(temp_words);
			}
			setLoadingWords(false);
			setLoading(false);
		} else {
			// Si no hay datos cacheados, trigger refetch
			refetchSeminaryData();
		}
	};
	const getCategoriesSeminary = (temp_words) => {
		// Usar datos cacheados de React Query
		if (categoriesData && categoriesData.categories) {
			const categories = categoriesData.categories.sort((a: any, b: any) =>
				a.family > b.family ? 1 : a.family < b.family ? -1 : 0
			);
			setCategories(categories);
			temp_words.forEach((element) => {
				element.categories_ids = [];
				element.categories_ids_del = [];
				categories.forEach((category) => {
					if (element.categoria.includes(category.family)) {
						element.categories_ids.push(parseInt(category.id));
						element.categories_ids_del.push(parseInt(category.id));
					}
				});
			});

			getSubcategoriesSeminary(temp_words);
		}
	};

	const getSubcategoriesSeminary = (temp_words) => {
		// Usar datos cacheados de React Query
		if (subCategoriesData && subCategoriesData.categories) {
			const subcategories = subCategoriesData.categories.sort((a: any, b: any) =>
				a.sub_family > b.sub_family ? 1 : a.sub_family < b.sub_family ? -1 : 0
			);
			setSubcategories(subcategories);

			temp_words.forEach((element) => {
				element.subcategories_ids = [];
				element.subcategories_ids_del = [];
				subcategories.forEach((subcategory) => {
					if (element.sub_categoria && element.sub_categoria.includes(subcategory.sub_family)) {
						element.subcategories_ids.push(parseInt(subcategory.id));
						element.subcategories_ids_del.push(parseInt(subcategory.id));
					}
				});
			});
		}
	};

	const filterByAll = (wordsB?: Array<any>) => {
		let wordsTemp =
			wordsB === undefined ? JSON.parse(JSON.stringify(words)) : JSON.parse(JSON.stringify(wordsB));
		let words_temp: any;
		const normalizedSearch = searchText
			.toLowerCase()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "");

		words_temp = wordsTemp.filter((word) => {
			const mainMatch =
				typeof word.palabra === "string" &&
				word.palabra.toLowerCase().includes(searchText.toLowerCase());

			const optionalMatch =
				typeof word.palabra_opcional === "string" &&
				word.palabra_opcional.toLowerCase().includes(searchText.toLowerCase());

			const meaningMatch = Array.isArray(word.significado)
				? word.significado.some((meaning) => {
						if (typeof meaning !== "string") {
							return false;
						}
						const normalizedMeaning = meaning
							.toLowerCase()
							.normalize("NFD")
							.replace(/[\u0300-\u036f]/g, "");
						return normalizedMeaning === normalizedSearch;
				  })
				: false;

			return mainMatch || optionalMatch || meaningMatch;
		});
		if (sort === "1") {
			words_temp = [...words_temp].sort(function (a, b) {
				return a.palabra.toLowerCase() < b.palabra.toLowerCase()
					? -1
					: a.palabra.toLowerCase() > b.palabra.toLowerCase()
					? 1
					: 0;
			});
		}
		if (sort === "2") {
			words_temp = [...words_temp].sort((a: any, b: any) => {
				return a.dificultad - b.dificultad;
			});
		}
		if (sort === "3") {
			words_temp = [...words_temp].sort((a: any, b: any) => {
				return b.dificultad - a.dificultad;
			});
		}
		if (sort === "4") {
			words_temp = [...words_temp].filter((x) => x.bookmark == 1);
		}
		if (languages.includes(sort)) {
			words_temp = [...words_temp].filter((x) => x.idioma.idioma === sort);
		}
		setWords(words_temp);
	};

	const filterBy = (e) => {
		setWords(wordsBackup);
	};

	const seeDefaultQuizInfo = (index) => {
		setQuizIndex(index);
		setShowQuiz(true);
	};

	const setWordCategory = (e) => {
		categories_opt = [];
		var temp_categories = [...e.target.selectedOptions];
		temp_categories.forEach((element) => {
			categories_opt.push(parseInt(element.value));
		});
		setWord({ ...word, categories_ids: categories_opt });
	};

	const setWordSubcategory = (e) => {
		var subTemp_categories: any = [];
		if (word.subsubcategories_ids && word.subcategories_ids) {
			word.subcategories_ids.map((id) => {
				subTemp_categories.push(id.toString());
			});
		}
		var options = e.target.selectedOptions;
		for (var i = 0, l = options.length; i < l; i++) {
			if (
				options[i].selected &&
				subTemp_categories.findIndex((e) => e === options[i].value) === -1
			) {
				subTemp_categories.push(options[i].value);
			} else {
				let idx = subTemp_categories.findIndex((e) => e === options[i].value);
				if (idx !== -1) {
					subTemp_categories.splice(idx, 1);
				}
			}
		}
		setWord({ ...word, subcategories_ids: subTemp_categories });
	};

	const setWordSeminaries = (e) => {
		const newValue = parseInt(e.target.value);
		let seminariosTemp = word.seminarios === undefined ? [] : [...word.seminarios];
		const index = seminariosTemp.findIndex((s) => s === newValue);

		if (index === -1) {
			seminariosTemp.push(newValue);
		} else {
			seminariosTemp.splice(index, 1);
		}
		setWord({ ...word, seminarios: seminariosTemp.sort((a, b) => a - b) });
	};

	// Function to validate word
	const validateWord = (word) => {
		let someEmpty = false;
		let messageError = "";

		if (typeof word.significado == "string") {
			word.significado = word.significado.split("|");
			word.significado.forEach((element, index) => {
				if (element.replace(/ *\([^)]*\) */g, "").length === 0) {
					someEmpty = true;
				}
				word.significado[index] = element.trim();
			});
		}

		if (word.significado === undefined || someEmpty) {
			messageError += "Uno de los significados esta vacío. \n";
		}
		if (word.palabra === undefined || word.palabra.trim() === "") {
			messageError += "La palabra en lengua de origen no debe de estar vacío. \n";
		}

		return messageError;
	};

	// Function to handle quote in word
	const handleQuoteInWord = (word) => {
		if (word.palabra.startsWith('"') && word.palabra.endsWith('"')) {
			word.palabra = word.palabra.replace(/"/g, '\\"');
		}
		return word;
	};

	// Function to process add word to DB
	const processAddWordToDb = async (word) => {
		await addWordDb(word)
			.then((res) => {
				setWordAdded(!word_added);
				setModal(!modal);
				// Revalidate los datos de la tabla para mostrar la nueva palabra
				refetchSeminaryData();
				refetchAllWordsData();
				refetchMeaningsData();
			})
			.catch((error) => {
				console.error(error);
			});
	};

	const addWord = async () => {
		// Validate word
		let wordT = word;
		const messageError = validateWord(wordT);
		if (messageError.length > 0) {
			alert(messageError);
			return;
		}

		// Process word
		wordT = await processWord(wordT);

		// Handle quote in word
		wordT = handleQuoteInWord(wordT);

		// Process add word to db
		await processAddWordToDb(word);
	};

	const deleteWordSeminary = (id) => {
		if (window.confirm("¿Está seguro de que desea eliminar este término?")) {
			deleteWord(id).then((res) => {
				// Revalidate todos los datos relevantes después de eliminar
				refetchSeminaryData();
				refetchAllWordsData();
				refetchMeaningsData();
			});
		}
	};
	const deleteCategorySeminary = (categoryId) => {
		setConfirmationModal({
			show: true,
			title: "Eliminar Categoría",
			message: "¿Está seguro de que desea eliminar esta categoría?",
			loading: false,
			onConfirm: () => {
				setConfirmationModal((prev) => ({ ...prev, loading: true }));
				deleteCategory(categoryId)
					.then((res) => {
						refetchSeminaryData(); // Refetch con React Query
						setConfirmationModal({
							show: false,
							title: "",
							message: "",
							loading: false,
							onConfirm: () => {},
						});
					})
					.catch((error) => {
						console.error("Error al eliminar categoría:", error);
						setConfirmationModal((prev) => ({ ...prev, loading: false }));
					});
			},
		});
	};

	const updateWordSeminary = async () => {
		try {
			let someEmpty = false;
			if (typeof word.significado == "string") {
				word.significado = word.significado.split("|");
				word.significado.forEach((element, index) => {
					if (element.replace(/ *\([^)]*\) */g, "").length === 0) {
						someEmpty = true;
					}
					word.significado[index] = element.trim();
				});
			}
			if (someEmpty) {
				if (someEmpty) return alert("Uno de los significados esta vacío.");
			} else {
				// Procesa la palabra y asocia los significados optimizados
				const wordT = await processWord(word);
				if (wordT.palabra.startsWith('"') && wordT.palabra.endsWith('"')) {
					wordT.palabra = wordT.palabra.replace(/"/g, '"');
				}
				updateWord(wordT).then(async (res) => {
					if (wordT.bookmark === 1) {
						await bookmarkWordFalse(wordT.id);
					}
					setWordAdded(!word_added);
					setModal(!modal);
					// Revalidate los datos después de actualizar
					refetchSeminaryData();
					refetchAllWordsData();
					refetchMeaningsData();

					// Invalidación agresiva adicional para asegurar sincronización global
					setTimeout(async () => {
						try {
							// Invalidar seminario actual
							await queryClient.invalidateQueries({
								queryKey: [`seminary-${user.id}-${seminaryNum}`],
							});
							// Invalidar colecciones generales relacionadas
							await Promise.all([
								queryClient.invalidateQueries({ queryKey: ["vocabulary"] }),
								queryClient.invalidateQueries({ queryKey: ["categories"] }),
								queryClient.invalidateQueries({ queryKey: ["subcategories"] }),
							]);
							// Invalidar keys con términos relevantes
							await queryClient.invalidateQueries({
								predicate: (q) =>
									q.queryKey?.some?.(
										(seg: any) =>
											typeof seg === "string" &&
											/(word|words|vocab|quiz|meaning|report|search|seminar)/i.test(seg)
									),
							});
							// Refetch activo inmediato para listas visibles
							await queryClient.refetchQueries({
								predicate: (q) =>
									q.queryKey?.some?.(
										(seg: any) => typeof seg === "string" && /(word|words|vocab|quiz)/i.test(seg)
									),
								type: "active",
							});
						} catch (e) {
							console.warn("Cache invalidation error (updateWordSeminary):", e);
						}
					}, 50);
				});
			}
		} catch (error) {
			console.error(error);
			return error;
		}
	};

	const previousSeminary = () => {
		setQuiz(new Array());
		if (+seminaryNum !== 0) {
			// Los datos ya están prefetcheados, navegación instantánea
			history.push({ pathname: "/admin/vocabulario/seminario/" + (+seminaryNum - 1) });
		}
	};

	const nextSeminary = () => {
		setQuiz(new Array());
		if (+seminaryNum !== 60) {
			// Los datos ya están prefetcheados, navegación instantánea
			history.push({ pathname: "/admin/vocabulario/seminario/" + (+seminaryNum + 1) });
		}
	};

	const editWord = async (word) => {
		let ret = "";

		if (word.significado && Array.isArray(word.significado)) {
			await Promise.all(
				word.significado.map((meaning, index) => {
					ret +=
						meaning +
						(word.significado.length > 1 && index <= word.significado.length - 2 ? "|" : "");
				})
			);
		}

		let editWordCategorie = categories.filter((e) => e.singular === word.singular_category);

		let editWordSubCategories: any = [];
		if (word.sub_categoria !== null && Array.isArray(word.sub_categoria)) {
			word.sub_categoria.map((sbc) => {
				editWordSubCategories.push(subcategories.filter((e) => e.sub_family === sbc)[0].id);
			});
		}

		// Procesar seminarios existentes
		let existingSeminaries: number[] = [];
		if (word.seminarios) {
			if (typeof word.seminarios === "string") {
				// Si es string separado por comas, convertir a array de números
				existingSeminaries = word.seminarios
					.split(",")
					.map((s) => parseInt(s.trim()))
					.filter((n) => !isNaN(n) && n >= 0 && n <= 60);
			} else if (Array.isArray(word.seminarios)) {
				// Si es array de objetos del backend: [{ seminary_id: 4, seminary_number: 4 }]
				existingSeminaries = word.seminarios
					.map((s) => {
						// Si es objeto con seminary_number, usar ese valor
						if (typeof s === "object" && s.seminary_number !== undefined) {
							return parseInt(s.seminary_number);
						}
						// Si es número directo, usarlo
						else if (typeof s === "number") {
							return s;
						}
						// Si es string, parsearlo
						else if (typeof s === "string") {
							return parseInt(s);
						}
						return null;
					})
					.filter((n) => n !== null && !isNaN(n) && n >= 0 && n <= 60);
			}
		}

		setWord({
			...word,
			significado: ret,
			categories_ids: [editWordCategorie[0].id],
			subcategories_ids: editWordSubCategories,
			seminarios: existingSeminaries,
		});
		setModal(true);
		setUpdate(true);
	};

	// useEffect para procesar datos cuando lleguen de React Query
	useEffect(() => {
		if (seminaryData && !isLoadingSeminary && categoriesData && subCategoriesData) {
			getWords();
		}
	}, [seminaryData, isLoadingSeminary, categoriesData, subCategoriesData]);

	// Prefetch de seminarios adyacentes para navegación más rápida
	useEffect(() => {
		const currentNum = +seminaryNum;

		// Prefetch seminario anterior
		if (currentNum > 0) {
			queryClient.prefetchQuery({
				queryKey: [`seminary-${currentNum - 1}`, {}],
				queryFn: () => wordsSeminary(currentNum - 1),
				staleTime: 5 * 60 * 1000,
			});
		}

		// Prefetch seminario siguiente
		if (currentNum < 60) {
			queryClient.prefetchQuery({
				queryKey: [`seminary-${currentNum + 1}`, {}],
				queryFn: () => wordsSeminary(currentNum + 1),
				staleTime: 5 * 60 * 1000,
			});
		}
	}, [seminaryNum, queryClient]);

	useEffect(() => {
		filterByAll();
	}, [sort, searchText]);

	useEffect(() => {
		// Refetch cuando se agregue una palabra
		if (word_added && seminaryNum) {
			refetchSeminaryData();
		}
	}, [word_added]);

	useEffect(() => {
		setWord({ ...word, [warningType]: value });
	}, [value]);

	if (loading || isLoadingCategories || isLoadingSubCategories) {
		return (
			<div
				style={{ height: "60vh", display: "flex", justifyContent: "center", alignItems: "center" }}
			>
				<div className="spinner-border text-danger" role="status">
					<span className="sr-only">Loading...</span>
				</div>
			</div>
		);
	}

	return (
		<div className="vocabulary-seminary-admin-main-container">
			<div className="button-container">
				<button
					className="goback-btn"
					style={{ height: "fit-content" }}
					onClick={() => history.push({ pathname: "/admin/vocabulario" })}
				>
					Atrás
				</button>
				<div className="move-btn">
					<p className="title-sem">Seminario</p>
					<div className="buttons-back-for">
						<button
							className={seminaryNum !== "0" ? "btn-back" : "btn-back dis-back"}
							onClick={previousSeminary}
						>
							<FaArrowLeft />
							Anterior
						</button>
						<button
							className={seminaryNum !== "60" ? "btn-forward" : "btn-forward dis-for"}
							onClick={nextSeminary}
						>
							Siguiente
							<FaArrowRight />
						</button>
					</div>
				</div>
			</div>
			{quiz.length > 0 && (
				<QuizDefaultInfoModal
					show={showQuiz}
					onHide={() => setShowQuiz(false)}
					quiz={quiz[quizIndex]}
				/>
			)}
			<div className="title">
				<h1>Seminario {seminaryNum}</h1>
			</div>
			<div className="subtitle">
				<h3>
					Revisa las listas de vocabularios para las clases y los progresos de los estudiantes
				</h3>
			</div>
			<Link to={`/admin/vocabulario/quiz/${seminaryNum}`}>
				<div className="row-container">
					<div className="config-test-card">
						<div className="title">
							<h3>Configurar ronda de estudio predeterminada</h3>
						</div>
						<div className="icon">
							{loadingWords ? (
								<CustomSpinner size={50} height={"auto"} borderSize={4} />
							) : (
								(languages || []).map((language, index) => {
									if (quiz.filter((e) => e.language === language).length > 0) {
										return (
											<div
												className="default-quizzes-container"
												key={"default-quiz-lang-" + language}
											>
												{returnFlagByLanguage(language)}
												<div className="number-of-default-quizzes-container">
													<h3>{quiz.filter((e) => e.language === language).length}</h3>
												</div>
											</div>
										);
									}
								})
							)}
							<img src={RocketIcon} alt="icono de cohete" />
						</div>
					</div>
				</div>
			</Link>
			<div className="words-container">
				<div className="filter-container">
					<div className="left">
						<select
							value={sort}
							onChange={(t: any) => {
								filterBy(setSort(t.target.value));
							}}
						>
							<option value={0}>Ordenar Por</option>
							<option value={1}>Alfabetico</option>
							<option value={4}>No Resueltas</option>
							{(languages || []).map((lang, i) => {
								if (wordsBackup.filter((w) => (w.idioma as any).idioma === lang).length > 0) {
									return (
										<option value={lang} key={"lang-option-filter-" + i}>
											{capitalizeFirstLetter(getLangSpanishSimple(lang))}
										</option>
									);
								}
							})}
						</select>
						<div className="search-container">
							<img src={LENLogo} alt="" />
							<input
								type="text"
								placeholder={input_buscar_terminos}
								onChange={(e: any) => filterBy(setText(e.target.value))}
							/>
						</div>
					</div>
					<button
						onClick={() => {
							setModal(!modal);
							setWord({ seminario: parseInt(seminaryNum) });
							setUpdate(false);
						}}
					>
						Añadir palabra
					</button>
				</div>
				<NotesModal
					show={notesModal.show}
					onHide={() => setNotesModal({ ...notesModal, show: false })}
					notes={notesModal.notes}
				/>
				<ConfirmationModal
					show={confirmationModal.show}
					title={confirmationModal.title}
					message={confirmationModal.message}
					loading={confirmationModal.loading}
					onHide={() => setConfirmationModal({ ...confirmationModal, show: false })}
					onConfirm={confirmationModal.onConfirm}
				/>
				<table className="table">
					<thead>
						<tr>
							<th scope="col">Palabra</th>
							<th scope="col">Traducción</th>
							<th scope="col" className="text-center">
								Dificultad
							</th>
							<th className="text-center" scope="col">
								Idioma
							</th>
							<th scope="col">Categoría</th>
							<th scope="col">Subcategoría</th>
							<th></th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{loadingWords ? (
							<tr>
								<td colSpan={8} className="text-center">
									<div
										className="d-flex align-items-center justify-content-center"
										style={{ minHeight: "200px" }}
									>
										<CustomSpinner size={50} height={"auto"} borderSize={4} />
									</div>
								</td>
							</tr>
						) : (
							words?.length > 0 && (
								<>
									{words?.map((word, index) => {
										return (
											<tr key={"word-" + index}>
												<th>
													{word.bookmark === 1 && (
														<span
															style={{ color: "red", cursor: "pointer" }}
															onClick={() => setNotesModal({ notes: word.notes, show: true })}
														>
															*
														</span>
													)}{" "}
													{word.palabra}{" "}
													{word.palabra_opcional !== null && <span>({word.palabra_opcional})</span>}
												</th>
												<td>
													{word.significado && Array.isArray(word.significado)
														? word.significado
																.filter((meaning) => meaning && meaning.toString().trim() !== "")
																.map((meaning, index, filteredArray) => {
																	return (
																		meaning +
																		(filteredArray.length > 1 && index <= filteredArray.length - 2
																			? ", "
																			: "")
																	);
																})
														: "Sin significado"}
												</td>
												<td>
													<div
														className="difficult-circle"
														style={{ backgroundColor: getDifficultColor2(+word.dificultad) }}
													>
														<p
															className="difficult-circle-message"
															style={word.dificultad !== null ? { display: "none" } : {}}
														>
															Sin datos de estudio
														</p>
													</div>
												</td>
												<td>
													<p className="row-languages justify-content-center">
														{returnFlagByLanguage((word.idioma as any).idioma)}
													</p>
												</td>
												<td>
													{word.categories_ids && word.categories_ids.length > 0 ? (
														word.categories_ids.map((categoryId, i) => {
															const category = categories.find((cat) => cat.id === categoryId);
															return (
																<div
																	key={"category-" + i}
																	style={{
																		display: "flex",
																		alignItems: "center",
																		marginBottom: "5px",
																	}}
																>
																	<p style={{ margin: "0 10px 0 0" }}>
																		{category ? category.singular : word.singular_category}
																	</p>
																	<img
																		src={Trash}
																		alt="Eliminar categoría"
																		style={{ cursor: "pointer", width: "16px", height: "16px" }}
																		onClick={() => {
																			deleteCategorySeminary(categoryId);
																		}}
																	/>
																</div>
															);
														})
													) : (
														<p>{word.singular_category}</p>
													)}
												</td>
												<td>
													{word.sub_categoria !== null &&
														Array.isArray(word.sub_categoria) &&
														word.sub_categoria.map((subcategory, i) => {
															return <p key={"sub-categoria-" + i}>{subcategory}</p>;
														})}
												</td>
												<td>
													<img
														src={Check}
														alt=""
														onClick={() => {
															editWord(word);
														}}
													/>
												</td>
												<td>
													<img
														src={Trash}
														alt=""
														onClick={() => {
															deleteWordSeminary(word.word_data_id);
														}}
													/>
												</td>
											</tr>
										);
									})}
								</>
							)
						)}
					</tbody>
				</table>
			</div>
			<Modal className="seminary-word-modal" show={modal} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Nueva Palabra</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<h6>Ingresa estos datos para poder crear la nueva palabra</h6>
					{word.notes !== undefined && word.notes.length > 0 && (
						<div>
							<label htmlFor="" className="m-0 font-weight-bold">
								Comentarios:
							</label>
							<p className="m-0">
								<span className="text-danger">*</span> {word.notes}
							</p>
						</div>
					)}
					<div className="modal-form">
						<div className="modal-row">
							<div className="modal-col">
								<label>Palabra en lengua origen</label>
								<input
									defaultValue={word.palabra}
									onChange={(e) => {
										setWord((word) => ({ ...word, palabra: e.target.value }));
									}}
									type="text"
									placeholder={input_palabra_original}
								/>
							</div>
							<div className="modal-col">
								<label>Traducción al español</label>
								<input
									value={word.significado}
									onChange={(e) => {
										setWord((word) => ({ ...word, significado: e.target.value }));
									}}
									type="text"
									placeholder={input_palabra_en_español}
									autoComplete="off"
								/>
								<legend className="mt-2">El carácter | es el separador de palabras.</legend>
							</div>
						</div>
						<div className="modal-row">
							<div className="modal-col">
								{word.idioma !== undefined && (word.idioma.id === 6 || word.idioma.id === 3) && (
									<>
										<label htmlFor="">Carácter</label>
										<input
											type="text"
											placeholder={word.idioma.id === 3 ? Kanji : Kanzi}
											defaultValue={word.palabra_opcional}
											onChange={(e) => {
												setWord((word) => ({
													...word,
													palabra_opcional: e.target.value,
												}));
											}}
										/>
									</>
								)}
							</div>
							<div className="modal-col"></div>
						</div>
						<div className="modal-row">
							<div className="modal-col">
								<label>Categoría</label>
								<select
									value={word.categories_ids}
									onChange={(e) => {
										setWordCategory(e);
									}}
								>
									<option value="">Seleccionar categoría</option>
									{categories.map((category, index) => {
										if (
											category.singular !== "" &&
											((parseInt(seminaryNum) > 0 && category.zero === 0) ||
												parseInt(seminaryNum) === 0)
										) {
											return (
												<option value={category.id} key={"category-" + index}>
													{category.singular}
												</option>
											);
										}
									})}
								</select>
							</div>
							<div className="modal-col">
								<label className="d-flex w-100 justify-content-between">
									Subcategoría
									<a
										style={{ cursor: "pointer" }}
										onClick={() => setWord({ ...word, subcategories_ids: [] })}
									>
										Limpiar
									</a>
								</label>
								<select
									value={word.subcategories_ids}
									size={5}
									multiple
									onChange={(e) => {
										setWordSubcategory(e);
									}}
								>
									<option value="">Seleccionar Subcategoría</option>
									{subcategories.map((subcategory, index) => {
										return (
											<option value={subcategory.id} key={"subcategory-" + index}>
												{subcategory.sub_family}
											</option>
										);
									})}
								</select>
							</div>
						</div>
						<div className="modal-row">
							<div className="modal-col">
								<label>Idioma</label>
								<select
									value={word.idioma?.id}
									onChange={(e) => {
										setWord((word) => ({ ...word, idioma: { id: parseInt(e.target.value) } }));
									}}
								>
									<option value="">Seleccionar Idioma</option>
									<option value="1">Francés</option>
									<option value="2">Alemán</option>
									<option value="3">Japonés</option>
									<option value="4">Italiano</option>
									<option value="5">Ruso</option>
									<option value="6">Chino</option>
									<option value="7">Portugués</option>
									<option value="8">Inglés</option>
								</select>
							</div>
							<div className="modal-col">
								<label>Aparece en material</label>
								<select
									value={word.paper}
									onChange={(e) => {
										setWord((word) => ({
											...word,
											paper: e.target.value,
										}));
									}}
								>
									<option value="Seleccionar opción"></option>
									<option value={1}>Si</option>
									<option value={0}>No</option>
								</select>
							</div>
						</div>
						<div className="modal-row">
							<div className="modal-col">
								<label className="d-flex w-100 justify-content-between">
									Seminarios
									<a
										style={{ cursor: "pointer" }}
										onClick={() => setWord({ ...word, seminarios: [] })}
									>
										Limpiar
									</a>
								</label>
								<select
									value={word.seminarios || []}
									size={8}
									multiple
									onChange={(e) => {
										setWordSeminaries(e);
									}}
									style={{ minHeight: "160px" }}
								>
									{(seminariesNumber || [])
										.sort((a, b) => a - b)
										.map((seminary, index) => {
											const isSelected = word.seminarios?.includes(seminary);
											return (
												<option
													value={seminary}
													key={"seminary-" + index}
													style={{
														backgroundColor: isSelected ? "#007bff" : "transparent",
														color: isSelected ? "white" : "black",
														padding: "4px 8px",
													}}
												>
													{seminary}
												</option>
											);
										})}
								</select>
								{word.seminarios && word.seminarios.length > 0 && (
									<small className="text-muted mt-2 d-block">
										<strong>Seleccionados:</strong>{" "}
										{word.seminarios.sort((a, b) => a - b).join(", ")}
									</small>
								)}
							</div>
							<div className="modal-col"></div>
						</div>
						<div className="modal-row">
							<div className="modal-col">
								<label>Nota</label>
								<div className="warning-note-inputs-container">
									{returnWarningTypeImage(warningType)}
									<select
										className="form-control"
										value={warningType}
										onChange={(e) => setWarningType(e.target.value)}
										name="warningType"
										id="warningType"
									>
										<option value="advertencia">Advertencia</option>
										<option value="memoria">Memoria</option>
										<option value="gramatica">Gramática</option>
										<option value="consejo">Consejo</option>
										<option value="falso_amigo">Falso amigo</option>
										<option value="similitud">Similitud</option>
										<option value="pronunciacion">Pronunciación</option>
										<option value="sabias_que">¿Sabías que...?</option>
									</select>
								</div>
								<div>
									{warn.map((val, index: number) => {
										if (val === warningType) {
											return (
												<ReactQuill
													modules={{ toolbar: toolbarOptions }}
													theme="snow"
													defaultValue={word[warningType]}
													onChange={setValue}
													key={"textQuill " + index}
												/>
											);
										}
									})}
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="buttons">
						<button className="close" onClick={handleClose}>
							Cerrar
						</button>
						{!update && (
							<button className="continue" onClick={addWord}>
								Continuar
							</button>
						)}
						{update && (
							<button className="continue" onClick={updateWordSeminary}>
								Editar
							</button>
						)}
					</div>
				</Modal.Footer>
			</Modal>
		</div>
	);
}

export default VocabularySeminaryContainer;
